import React from "react";
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
} from "recharts";
import { formatMoney } from "@/lib/format";
import { useT } from "@/lib/i18n";

const RANGES = [
  { k: "7d", label: "7 jours" },
  { k: "30d", label: "30 jours" },
  { k: "12m", label: "12 mois" },
];

export default function RevenueChart({ data, currency, range, onRange }) {
  const { t } = useT();
  const chartData = (data || []).map((d) => ({ label: d.label, value: d.value_cents / 100 }));

  return (
    <div className="rounded-xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_3px_0_rgba(15,23,42,0.04)]" data-testid="revenue-chart-panel">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-slate-900">{t("dash.revenue_evolution")}</h3>
        <div className="flex gap-1 rounded-lg bg-slate-100 p-0.5">
          {RANGES.map((r) => (
            <button key={r.k} onClick={() => onRange(r.k)} data-testid={`revenue-range-${r.k}`}
              className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${range === r.k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}>
              {r.label}
            </button>
          ))}
        </div>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData} margin={{ top: 5, right: 8, left: -8, bottom: 0 }}>
            <defs>
              <linearGradient id="revGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#059669" stopOpacity={0.25} />
                <stop offset="100%" stopColor="#059669" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} minTickGap={16} />
            <YAxis tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} width={48}
              tickFormatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v)} />
            <Tooltip
              contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 12, boxShadow: "0 10px 25px -5px rgba(15,23,42,0.1)" }}
              formatter={(v) => [formatMoney(v * 100, currency), "CA"]}
              labelStyle={{ color: "#0f172a", fontWeight: 600 }} />
            <Area type="monotone" dataKey="value" stroke="#059669" strokeWidth={2.5} fill="url(#revGrad)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
